import { PERMISSION } from './permissions.js';
/** Query upstream data without granting any manual quantity-edit capability. */
export const SOURCE_QUANTITY_SYNC_PERMISSIONS = [PERMISSION.SHEET_UPDATE, PERMISSION.SPEC_MATERIAL_USAGE_EDIT];
//# sourceMappingURL=source-quantity-sync.js.map